<template>
    <div class="project-picker">
        <sd-sheet :show.sync="showSheet" :title="title || $t('text.perfect_tyui')" close ref="sheet">
            <picker-scroll :index.sync="pickerIndex" :data="pickerData"></picker-scroll>
            <div class="picker-button"><sd-button @click.native="confirm()">{{$t('text.confirm')}}</sd-button></div>
        </sd-sheet>
    </div>
</template>

<script>
import sdSheet from "./sheet.vue";
import pickerScroll from "../base/picker-scroll.vue"

export default {
    name: "sd-picker",
    components: { sdSheet, pickerScroll },
    props: {
        show: Boolean,
        data: Array,
        title: String,
        index: Number,
    },
    data() {
        return {
            showSheet: this.show,
            
            pickerIndex: 0,
        }
    },
    computed: {
        pickerData() {
            return this.data
        }
    },
    watch: {
        show(val) {
            this.showSheet = val;
            if(val) this.init();
        },
        showSheet(val) {
            this.$emit("update:show", val)
        },
        index(val) {
            this.pickerIndex = val;
        }
    },
    mounted() {
        this.show && this.init();
    },
    methods: {
        init() {
            this.pickerIndex = this.index || 0;
        },

        confirm() {
            const value = this.data[this.pickerIndex].value
            this.$emit("confirm", value);
            this.$refs.sheet.hidden();
        }
    }
}
</script>

<style lang="scss" scoped>
    .project-picker {

        .picker-button {
            display: flex;
            padding: 0 20px 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/common/picker.vue